<template>
	<div class="col-12 col-lg-4">
		<div
			id="example-input-group-3"
			class="form-group"
			:class="{
				'form-group--error': isValidate === false,
				'form-group--success': isValidate === true,
			}"
			:state="isValidate"
		>
			<label for="phone_input" class="d-block col-form-label-sm">Телефон</label>
			<VuePhoneNumberInput
				id="phone_input"
				name="phone"
				color="#000000"
				default-country-code="RU"
				:border-radius="0"
				:no-country-selector="false"
				:no-flags="true"
				:no-example="true"
				:show-code-on-list="true"
				:translations="{
					countrySelectorLabel: '',
					countrySelectorError: 'Выберите страну',
					phoneNumberLabel: 'Введите ваш номер телефона',
					example: 'Пример:'
				}"
				:value="value"
				@input="$emit('input', $event)"
				@change="$emit('change', $event)"
				@phone-number-blur="onBlur(value)"
				@update="phoneUpdate"
			/>
			<div
				v-if="isValidate === false"
				class="error"
				for="phone_input"
			>
				Пожалуйста, укажите ваш номер телефона
			</div>
		</div>
	</div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';

export default {
	name: 'Phone',
	components: {
		VuePhoneNumberInput,
	},
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		value: { type: String, default: null },
	},
	data() {
		return {
			isValidate: null,
			isCustomValidate: null,
		};
	},
	methods: {
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 *
		 * Если какие-то поля имеют дополнительную валидацию - то они могут изменить true валидность на false.
		 * Но не могут изменить false на true. Т.к. валидация, приходящая из бэка - более приоритетная.
		 * И не могут изменить undefined на false. Например, если телефон не обязателен, а заполнен неправильно - он все равно true.
		 *
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			if (this.value) {
				const isValid = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;

				if (isValid === false) this.isValidate = false;
				if (isValid === true && this.isCustomValidate === true) this.isValidate = true;
				if (isValid === true && this.isCustomValidate === false) this.isValidate = false;
				if (typeof isValid === 'undefined' || isValid === null) this.isValidate = true;
			} else {
				this.isValidate = false;
			}
			return this.isValidate;
		},
		phoneUpdate(payload) {
			this.isCustomValidate = payload.isValid;
			this.$emit('update', {...payload, key: 'formatInternational'});
		},
		onBlur(value) {
			this.$emit('blur', value);
		},
	},
};
</script>


<style style lang="scss">
	.input-tel__label {
		top: -8px !important;
	}
	.error {
		width: 100%;
		margin-top: 0.25rem;
		font-size: 80%;
		color: #dc3545;
	}
</style>
